/*******************************************
*  Mixin to generate typographic pairings of heading and paragraph: h2-p, h3-p, etc, etc.
*******************************************/
/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-loader.get-names.ts 
*/
:host {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: unset;
  font: inherit;
  display: contents;
  box-sizing: border-box;
}
:host * {
  box-sizing: border-box;
}

.ace-loader {
  display: inline-block;
  position: relative;
  background: var(--ace-color-surface-gradient--conic);
  border-radius: 50%;
  animation: loader-motion 2s ease-in-out infinite;
  height: 3rem;
  width: 3rem;
  -webkit-mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - 0.5rem), #fff 0);
  mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - 0.5rem), #fff 0);
}
.ace-loader--animation-disabled {
  animation: none;
}
.ace-loader--size-medium {
  height: 3rem;
  width: 3rem;
  -webkit-mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - 0.5rem), #fff 0);
  mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - 0.5rem), #fff 0);
}
.ace-loader--size-x-small {
  height: 1.5rem;
  width: 1.5rem;
  -webkit-mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - 0.25rem), #fff 0);
  mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - 0.25rem), #fff 0);
}
.ace-loader--size-xx-small {
  height: 1.25rem;
  width: 1.25rem;
  -webkit-mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - 0.21rem), #fff 0);
  mask: radial-gradient(farthest-side, rgba(0, 0, 0, 0) calc(100% - 0.21rem), #fff 0);
}
.ace-loader--force-mode-light {
  background: var(--ace-color-surface-gradient--conic-white);
}
.ace-loader--force-mode-dark {
  background: var(--ace-color-surface-gradient--conic-black);
}

@keyframes loader-motion {
  0% {
    transform: rotate(0deg);
  }
  25% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}